"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.search");
var _ReferralPurchaseEdit = _interopRequireDefault(require("./ReferralPurchaseEdit.vue"));
var _ReferralPurchaseTable = _interopRequireDefault(require("./ReferralPurchaseTable.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'referal_purchase',
  // 菜品活动-推荐购
  components: {
    ReferralPurchaseTable: _ReferralPurchaseTable.default,
    ReferralPurchaseEdit: _ReferralPurchaseEdit.default
  },
  data: function data() {
    return {
      activeName: 'table',
      referralFnId: null
    };
  },
  created: function created() {},
  methods: {
    handleSuccess: function handleSuccess() {
      this.activeName = 'table';
      this.$refs.referral_purchase_table.search();
    },
    addActivity: function addActivity() {
      this.activeName = 'config';
    },
    handleClick: function handleClick(tab) {
      console.log(tab);
      this.activeName = tab.name;
      if (tab.name === 'table') {
        this.referralFnId = null;
      }
    },
    editActivity: function editActivity(referralFnId) {
      this.activeName = 'config';
      this.referralFnId = referralFnId;
    }
  }
};